"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var legacy_1 = require("satcheljs/lib/legacy");
var store_1 = require("../store/store");
var nextId = 0;
exports.default = legacy_1.action('addNotification')(function addNotification(notificationViewState) {
    var notification = tslib_1.__assign({ id: nextId++ }, notificationViewState);
    store_1.default.notificationViewStates.push(notification);
});
//# sourceMappingURL=addNotification.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-header-toast-notification/lib/actions/addNotification.js
// module id = 1614
// module chunks = 3 14 105 106 107